// Handling login APIs

jQuery(function ($) {
  if ($("#csv-upload-form-container").length <= 0) {
    return;
  }

  console.log("csvimport Ready");

  const BASEURL = $("#base-url").data("url");

  let file;

  const fileInput = document.getElementById('csvFile');

  fileInput.addEventListener('change', function(event) {
    file = event.target.files[0];
    $('.error-message').hide();
  });

  $("#uploadForm").on("submit", function (event) {
    event.preventDefault();

    $('.error-message').hide();


    if (!file) {
      $('.error-message').text('No file selected!');
      $('.error-message').show();
      console.log('Error: No file selected');
      return;
    }

    const extension = getFileExtension(file.name);

    if (extension !== 'csv') {
      $('.error-message').text('Please select a CSV file!');
      $('.error-message').show();
      return;
    }

    let skip = $('#skip').val();

    skip = skip === '' ? 0 : parseInt(skip);

    $('#import-loading').fadeIn();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('skip', skip);
  
    fetch(BASEURL + 'api/upload-csv', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      const messages = data.data;

      if (messages.length > 0) {
        messages.map((m) => {
          console.log('m', m);

          if (m.type === 'node_created') {
            $('#import-results').append('<div class="import-result--message p-3 bg-green-100"><div class="flex justify-between gap-5"><div class="flex-shrink-0 whitespace-nowrap w-[100px]">Row ' + m.row + '</div><div class="flex-grow"><strong>Node created:</strong> ' + m.message + '</div><div class="flex-shrink-0 flex flex-nowrap gap-8"><a href="' + m.permalink + '" target="_blank">View</a><a href="' + m.permalink + '/edit" target="_blank">Edit</a></div></div></div>');
          }

          if (m.type === 'node_error') {
            $('#import-results').append('<div class="import-result--message p-3 bg-red-100"><div class="flex justify-between gap-5"><div class="flex-shrink-0 whitespace-nowrap w-[100px]">Row ' + m.row + '</div><div class="flex-grow"><strong>Node error:</strong> Row:' + m.row + ',' + m.message + '</div><div class="flex-shrink-0 flex flex-nowrap gap-8"></div></div></div>');
          }

          if (m.type === 'term_created') {
            $('#import-results').append('<div class="import-result--message p-3 bg-blue-100"><div class="flex justify-between gap-5"><div class="flex-shrink-0 whitespace-nowrap w-[100px]"></div><div class="flex-grow"><strong>Term created:</strong> ' + m.message + '</div><div class="flex-shrink-0 flex flex-nowrap gap-8"><a href="' + m.permalink + '" target="_blank">View</a><a href="' + m.permalink + '/edit" target="_blank">Edit</a></div></div></div>');
          }

          if (m.type === 'term_error') {
            $('#import-results').append('<div class="import-result--message p-3 bg-red-100"><div class="flex justify-between gap-5"><div class="flex-shrink-0 whitespace-nowrap w-[100px]">Row ' + m.row + '</div><div class="flex-grow"><strong>Term error:</strong> Row:' + m.row + ',' + m.message + '</div><div class="flex-shrink-0 flex flex-nowrap gap-8"></div></div></div>');
          }

          if (m.type === 'unknown_term') {
            $('#import-results').append('<div class="import-result--message p-3 bg-red-100"><div class="flex justify-between gap-5"><div class="flex-shrink-0 whitespace-nowrap w-[100px]"></div><div class="flex-grow"><strong>Unknown term:</strong> ' + m.message + '</div></div></div>');
          }
        });
  
        $('#uploadForm').remove();
        $('#import-results-container').show();
      }
    })
    .catch(error => {
      console.error('Error:', error);
      $('.error-message').text('Import failed or partially completed!');
      $('.error-message').show();
      $('#import-loading').fadeOut();
    });

    function getFileExtension(fileName) {
      const extensionMatch = fileName.match(/\.([^.]+)$/);
      return extensionMatch ? extensionMatch[1].toLowerCase() : '';
    }
  });
});
